import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "selectAll", "normalActions", "afterSelectActions", "reviewIdsInput", "selectAllInput"]
  static values = {
    reviewIds: { type: Array, default: [] },
    selectAll: { type: Boolean, default: false }
  }

  checkAll(event) {
    this.selectAllValue = event.currentTarget.checked
  }

  selectAllValueChanged() {
    this.inputTargets.forEach((input) => {
      input.checked = this.selectAllValue
      input.disabled = this.selectAllValue
    })

    if (!this.selectAllValue) this.reviewIdsValue = []
    this.selectAllInputTargets.forEach((input) => { input.value = this.selectAllValue ? "1" : "0" })

    this.refreshActions()
  }

  toggleReviewId(event) {
    if (this.selectAllValue) return

    const reviewId = event.currentTarget.value
    if (event.currentTarget.checked) {
      this.reviewIdsValue = [...this.reviewIdsValue, reviewId]
    } else {
      this.reviewIdsValue = this.reviewIdsValue.filter((id) => id !== reviewId)
    }
  }

  reviewIdsValueChanged() {
    this.reviewIdsInputTargets.forEach((input) => { input.value = JSON.stringify(this.reviewIdsValue) })
    this.refreshActions()
  }

  refreshActions() {
    if (!this.hasAfterSelectActionsTarget || !this.hasNormalActionsTarget) return

    const active = this.selectAllValue || this.reviewIdsValue.length > 0
    this.afterSelectActionsTarget.classList.toggle("hidden", !active)
    this.normalActionsTarget.classList.toggle("hidden", active)
  }
}
